export const Logo = ({ variant = "light", className = "h-11 w-auto sm:h-12" }) => (
  <img
    src={variant === "light" ? "/logo-light.png" : "/logo.png"}
    alt="Bodhatek — Managed. Dispatched. Delivered."
    className={className}
    width="492"
    height="220"
  />
);
